import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { Address } from '../models/address.model';
import { Observable, observable } from 'rxjs';
import { GeoCodeLookupAPIResponse } from 'src/interfaces';

export class AddressEndpoint {
  endpoint = 'addresses/';
  constructor(private apiService: APIServiceService) {}



  async createOrUpdate(address: Address): Promise<{success: boolean, data: { results: Address }}> {
    const token = await this.apiService.getCurrentUserToken();
    if (!token) {
      throw new Error('no_auth_token');
    }
    try {
      const response = await this.apiService.doPOST(this.endpoint, token, address).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }

  async geoLookup(term: string): Promise<GeoCodeLookupAPIResponse> {
    //const token = this.apiService.getCurrentUserToken();
    // if (!token) {
    //   throw new Error('no_auth_token');
    // }
    try {
      const response = await this.apiService.doGET(this.endpoint + '/lookup', null, { term }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async lookupPostcode(postcode: string): Promise<any> {
    const token = await this.apiService.getCurrentUserToken();
    if (!token) {
      throw new Error('no_auth_token');
    }
    try {
      const response = await this.apiService.doGET(this.endpoint + '/lookup/postcode', token, { postcode }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  
  async searchAddress(term: string): Promise<any> {
    const token = await this.apiService.getCurrentUserToken();
    if (!token) {
      throw new Error('no_auth_token');
    }
    try {
      const response = await this.apiService.doGET(this.endpoint + '/search', token, { term }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }





}
